import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import AnimatedLabel from './AnimatedLabel';
import OfflineIcon from '../../kit/icons/OfflineIcon';
import OnlineIcon from '../../kit/icons/OnlineIcon';
import styles from './locationStyles';

const createIconComponent = (type) => {
  switch (type) {
    case 'online': {
      return <OnlineIcon fill="currentColor" sx={styles.iconSvg} />;
    }
    case 'offline': {
      return <OfflineIcon fill="currentColor" sx={styles.iconSvgStroke} />;
    }
  }
};

function LocationLabel({ theme, type, title }) {
  return (
    <AnimatedLabel theme={theme}>
      <Box sx={styles.location}>
        {type && <Box sx={styles.icon}>{createIconComponent(type)}</Box>}
        {title ? (
          <Typography component="span">{title}</Typography>
        ) : (
          <Skeleton width="50px" height="17.5px" />
        )}
      </Box>
    </AnimatedLabel>
  );
}

export default LocationLabel;
